import React, { memo } from 'react';
import ProductTile from '../productTile';
import { theme } from './_vars';
import { pricesForGroup, findDiscount } from '@srcDS/utils/helpers';

const ProductNostoTile = ({ product, loggedIn, customerGroupId, sendEvent = () => {} }) => {
  const {
    productId,
    skus,
    variants,
    images,
    productName,
    tags,
    label,
    projectSpecificData: { prices, vipPrices, discounts },
    url,
  } = product;
  const variantList = variants || skus;

  const { price: regularPrice, discountedPrice, onSale } = pricesForGroup(prices, vipPrices, loggedIn, customerGroupId);

  const promoContent = findDiscount(discounts, {
    loggedIn,
    vipPrices,
    onSale,
    customerGroupId,
  });

  const initialVariant = {
    ...variantList?.[0],
    sku: variantList[0]?.name,
    attributes: {
      ...variantList?.[0]?.attributes,
    },
  };

  return (
    <ProductTile
      parentProduct={product}
      productId={productId}
      data-id={productId}
      data-sku={initialVariant.sku}
      remoteImage={false}
      productName={productName}
      position={product['__position']}
      images={images}
      regularPrice={regularPrice}
      onSale={onSale}
      discountedPrice={discountedPrice}
      inOnStock={initialVariant.inOnStock}
      promoContent={promoContent}
      currency={initialVariant.currency}
      url={url}
      variants={variants}
      item={initialVariant}
      tags={tags}
      placement={'Listing Page | Search'}
      productType={product.type || product.slug}
      label={label}
      theme={theme}
      gridType="wide"
      enableGallery={true}
      enableTouchOnMobile={true}
      finalSale={null}
    />
  );
};
export default memo(ProductNostoTile);
